import React, { Component } from 'react';
import b from 'b_';
import { Event } from 'client/types/event';
import { List } from 'client/types/common';
import EventCard from 'client/components/event-card';
import EventsStub from './events.stub';

import './events.css';

const class_ = b.with('events');

interface Props {
    isLoading?: boolean;
    onClickToShowMore: () => void;
    data: List<Event>;
}

export default class Events extends Component<Props> {
    render() {
        const { isLoading, data: { meta, rows } } = this.props;
        const { pageNumber = 1, pageSize = 8 } = meta;

        // Если грузим не первую страницу, то загруженные меропрития не мокаем
        if (isLoading && pageNumber === 1) {
            return <EventsStub limit={pageNumber! * pageSize!} />;
        }

        if (!rows.length) {
            return (
                <div className={class_()}>
                    <div className={class_('container')}>
                        Таких мероприятий не нашлось.<br />
                        Пожалуйста, выберите другое сочетание фильтров.
                    </div>
                </div>
            );
        }

        return (
            <div className={class_()}>
                <div className={class_('container')}>
                    {rows.map(this.renderEvent)}
                    <div className={class_('fake-space-item')} />
                    <div className={class_('fake-space-item')} />
                    <div className={class_('fake-space-item')} />
                </div>
                {this.renderHasMore()}
            </div>
        );
    }

    private renderHasMore = () => {
        const { isLoading, data: { meta, rows } } = this.props;
        const { totalSize } = meta;
        const hasMore = totalSize! > rows.length;

        return hasMore && !isLoading && (
            <div className={class_('more-container')}>
                <a
                    href="#"
                    className={class_('more')}
                    onClick={this.onClickToShowMore}
                >
                    Показать еще
                </a>
            </div>
        );
    };

    private renderEvent = (event: Event) => (
        <EventCard
            key={event.id}
            data={event}
        />
    );

    private onClickToShowMore = (e: React.MouseEvent) => {
        e.preventDefault();

        this.props.onClickToShowMore();
    };
}
